import React from "react";
import ITitle from "./interface";
import Container from "./styles";

const Title: React.FC<ITitle> = ({color, size = "sm", marginBottom, marginTop, bold, styleInline, children, onClick, hexColor}) => <Container color={color} size={size} marginBottom={marginBottom} marginTop={marginTop} bold={bold} styleInline={styleInline} onClick={onClick} hexColor={hexColor}>{children}</Container>;

export default Title;
